import React from "react";

const LoadingUI = () => {
  return (
    <div id="Loading" className="modal">
      <div className="dot-pulse"></div>
    </div>
  );
};

export default LoadingUI